import { SFCCBasket } from '@gn-audio/jss-core';

export const calculateBasketSize = (basket?: SFCCBasket): number => {
  if (!basket) return 0;
  return (
    basket?.product_items?.reduce((sum, product) => {
      if (product.c_isService) {
        return sum;
      }
      return product.quantity + sum;
    }, 0) ?? 0
  );
};
